<div [formGroup]="formGroup">
  <mat-form-field class="w-full" appearance="outline">
    <mat-label>Threshold Type</mat-label>
    <mat-select formControlName="threshold_type">
      <mat-option *ngFor="let item of thresholdTypes; trackBy: trackByValue" [value]="item.type">{{
        item.label
      }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="w-full" appearance="outline">
    <mat-label>Upper Threshold{{ state.isRelative ? ' (more than 1)' : '' }}</mat-label>
    <input type="number" matInput autocomplete="off" step="any" formControlName="upper_threshold" />
    <mat-error *ngIf="formGroup.controls.upper_threshold.errors?.required" class="mat-error-default">
      Value is required
    </mat-error>
    <mat-error *ngIf="formGroup.controls.upper_threshold.errors?.min as errorMin" class="mat-error-default">
      Value should be more than {{ errorMin.min }}
    </mat-error>
    <mat-error *ngIf="formGroup.controls.upper_threshold.errors?.max as errorMax" class="mat-error-default">
      Value should be less than {{ errorMax.max }}
    </mat-error>
    <mat-error *ngIf="formGroup.controls.upper_threshold.errors?.integer" class="mat-error-default">
      Value should be integer
    </mat-error>
  </mat-form-field>

  <mat-form-field class="w-full" appearance="outline">
    <mat-label>Lower Threshold{{ state.isRelative ? ' (from 0 to 1)' : '' }}</mat-label>
    <input type="number" matInput autocomplete="off" step="any" formControlName="lower_threshold" />
    <mat-error *ngIf="formGroup.controls.lower_threshold.errors?.required" class="mat-error-default">
      Value is required
    </mat-error>
    <mat-error *ngIf="formGroup.controls.lower_threshold.errors?.min as errorMin" class="mat-error-default">
      Value should be more than {{ errorMin.min }}
    </mat-error>
    <mat-error *ngIf="formGroup.controls.lower_threshold.errors?.max as errorMax" class="mat-error-default">
      Value should be less than {{ errorMax.max }}
    </mat-error>
    <mat-error *ngIf="formGroup.controls.lower_threshold.errors?.integer" class="mat-error-default">
      Value should be integer
    </mat-error>
  </mat-form-field>
</div>
